import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query GlobalKeys($page: Int, $perPage: Int, $search: String) {
    GlobalKeys(page: $page, perPage: $perPage, search: $search) {
      items {
        key
        value
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  key: string;
  value: string;
}

export interface GetAllGql {
  GlobalKeys: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
